import * as React from "react";
import { Facebook, Instagram, Twitter, ArrowUp, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer({
  title
}: {
  title: string;
}) {
  const {
    menuItems,
    loading,
    error
  } = useMenu();
  if (loading) {
    return <div data-section-id="8438" className="space-y-4">
        <h3 className="text-lg font-serif font-bold tracking-tight text-primary-foreground">{title}</h3>
        <div className="flex flex-col gap-2">
          <div className="h-4 w-24 bg-white/10 animate-pulse rounded-sm" />
          <div className="h-4 w-32 bg-white/10 animate-pulse rounded-sm" />
          <div className="h-4 w-20 bg-white/10 animate-pulse rounded-sm" />
        </div>
      </div>;
  }
  if (error || !menuItems || menuItems.length === 0) {
    return null;
  }
  return <div className="space-y-4">
      <h3 className="text-lg font-serif font-bold tracking-tight text-primary-foreground">{title}</h3>
      <NavigationMenu viewport={false} className="max-w-full justify-start items-start">
        <NavigationMenuList className="flex-col items-start space-x-0 gap-2">
          {menuItems.map(item => <NavigationMenuItem key={item.id} className="w-full">
              <NavigationMenuLink asChild className="h-auto p-0 hover:bg-transparent focus:bg-transparent">
                <Link to={item.href || "#"} className="text-secondary-foreground/80 hover:text-primary-foreground transition-colors text-sm font-sans block w-full py-1">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>
    </div>;
}
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const currentYear = new Date().getFullYear();
  return <footer id="подвал-сайта" className="dark bg-primary text-primary-foreground border-t border-white/5">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {}
          <div className="space-y-6">
            <Link to="/HomePage" className="block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602611/img/logo_colortrend.png" alt="Адвокат Николай Кондрашов" className="h-8 w-auto object-contain brightness-0 invert" />
            </Link>
            <div className="space-y-1">
              <p className="text-secondary-foreground/90 font-serif text-base leading-relaxed max-w-xs">
                Квалифицированная юридическая помощь в Калуге.
              </p>
              <p className="text-secondary-foreground/60 font-mono text-[10px] uppercase tracking-widest">Реестровый номер 40/806<br />в реестре адвокатов калужской области</p>
            </div>
            <div className="space-y-2 pt-2">
              <div className="flex items-center gap-2 text-sm text-secondary-foreground/80 font-sans">
                <MapPin className="size-4 shrink-0 text-secondary-foreground/60" />
                <span>248 001, г. Калуга, ул. Кирова, д. 2, БЦ "ПЛАЗА", оф. 701, 7 этаж</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-secondary-foreground/80 font-sans">
                <Phone className="size-4 shrink-0 text-secondary-foreground/60" />
                <span>+7 (995) 305-79-51</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-secondary-foreground/80 font-sans">
                <Mail className="size-4 shrink-0 text-secondary-foreground/60" />
                <span>lawhelpklg@gmail.com</span>
              </div>
            </div>
          </div>

          {}
          <div className="footer-menu-column" data-wvc-dynamic="MenuProvider">
            <MenuProvider menu_id="17">
              <FooterMenuConsumer title="Услуги" />
            </MenuProvider>
          </div>

          {}
          <div className="footer-menu-column" data-wvc-dynamic="MenuProvider">
            <MenuProvider menu_id="16">
              <FooterMenuConsumer title="Информация" />
            </MenuProvider>
          </div>

          {}
          <div className="space-y-4">
            <h3 className="text-lg font-serif font-bold tracking-tight text-primary-foreground">Связь с адвокатом</h3>
            <p className="text-sm text-secondary-foreground/70 font-sans mb-4">
              Следите за изменениями в законодательстве и судебной практике в моих социальных сетях.
            </p>
            <div className="flex gap-4">
              <Link to="https://ru.linkedin.com/in/urist-kondrashovne" className="bg-white/5 p-2 rounded-sm text-primary-foreground hover:bg-white/15 transition-all duration-300 border border-white/10" aria-label="LinkedIn">
                <Facebook className="size-5" />
              </Link>
              <Link to="https://t.me/Lawhelpklg" className="bg-white/5 p-2 rounded-sm text-primary-foreground hover:bg-white/15 transition-all duration-300 border border-white/10" aria-label="Telegram">
                <Twitter className="size-5" />
              </Link>
              <Link to="https://www.instagram.com/kondrashov_advokat" className="bg-white/5 p-2 rounded-sm text-primary-foreground hover:bg-white/15 transition-all duration-300 border border-white/10" aria-label="Instagram">
                <Instagram className="size-5" />
              </Link>
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[10px] text-secondary-foreground/50 font-sans text-center md:text-left leading-normal max-w-2xl uppercase tracking-tighter">© 2026 Адвокат Н.Е. Кондрашов. Оказание юридической помощи осуществляется в соответствии с ФЗ «Об адвокатской деятельности и адвокатуре в РФ». Информация на сайте не является консультацией.</p>
          
          <div className="flex items-center gap-4">
            <Link to="#" className="text-[10px] text-secondary-foreground/60 hover:text-primary-foreground transition-colors uppercase tracking-widest font-mono">
              Конфиденциальность
            </Link>
            <Button variant="ghost" size="sm" onClick={scrollToTop} className="gap-2 text-secondary-foreground/60 hover:text-primary-foreground hover:bg-white/5">
              Наверх
              <ArrowUp className="size-4" />
            </Button>
          </div>
        </div>
      </div>
    </footer>;
}